import { render, staticRenderFns } from "./Mongodb.vue?vue&type=template&id=9b329018&"
import script from "./Mongodb.vue?vue&type=script&lang=js&"
export * from "./Mongodb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports